<template>
  <div class="spreedly-express-checkout"></div>
</template>

<script>
import { axios } from "@/store/fetch";
import FormattersMixin from "@/mixins/formatters-mixin";

export default {
  name: "SpreedlyExpressCheckout",
  mixins: [FormattersMixin],
  props: ["environmentKey", "reservationData"],
  data: () => ({
    isLoading: false,
  }),
  mounted() {
    this.loadSpreedlyScript();
    this.addHtmlStyles();
  },
  beforeDestroy() {
    this.removeHtmlStyles();
    window.SpreedlyExpress.unload();
  },
  methods: {
    loadSpreedlyScript() {
      if (window.SpreedlyExpress) return this.initializeSpreedly();

      const script = document.createElement("script");
      script.src = "https://core.spreedly.com/iframe/express-3.min.js";
      script.async = true;
      document.head.appendChild(script);
      script.onload = () => {
        this.initializeSpreedly();
      };
    },
    async initializeSpreedly() {
      this.isLoading = true;
      try {
        const { amount, listing_nickname, company_name, description } =
          this.reservationData;
        window.SpreedlyExpress.init(this.environmentKey, {
          amount: `${this.toMoney(amount, 2, this.currencySign)}`,
          company_name: listing_nickname,
          sidebar_top_description: company_name,
          sidebar_bottom_description: description,
          full_name: "",
        });
        window.SpreedlyExpress.openView();
        window.SpreedlyExpress.onPaymentMethod((token, pmData) => {
          this.handlePaymentMethod(token, pmData);
        });
        window.SpreedlyExpress.onViewClose(() => {
          this.removeHtmlStyles();
        });
      } catch (error) {
        console.error("Error initiating Spreedly Express:", error);
        this.isLoading = false;
      }
    },
    async handlePaymentMethod(token, { full_name }) {
      this.isLoading = true;
      this.$emit("payment-loading", true);
      try {
        await axios.post("/create-spreedly-reservation", {
          payment_method_token: token,
          payment_intent_id: this.reservationData.payment_intent_id,
          full_name,
        });
        console.log("Payment successful");
        this.$emit("payment-loading", false);
        // Navigate to the success page
        this.$router.push("/success");
      } catch (e) {
        console.error("Payment failed:", e);
        this.$emit("payment-loading", false);
        this.$router.push("/cancel");
      } finally {
        this.isLoading = false;
      }
    },
    addHtmlStyles() {
      document.documentElement.style.overflow = "hidden";
    },
    removeHtmlStyles() {
      document.documentElement.style.overflow = "auto";
    },
  },
};
</script>
